import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { URL_IMG } from '../../../configs/urlConfigs';
import { LBL_MUTE_EMAILS, LBL_MUTE_NOTICATIONS, LBL_SLNUM, LBL_NAME, LBL_POSITION, LBL_PHONE, LBL_EMAIL, LBL_CONTACT_DETAILS, LBL_CSV_IMPORT, LBL_DELETE, LBL_EDIT, LBL_PROFILE_NAME, LBL_FIRST_NAME, LBL_EMAIL_ADDRESS, LBL_RESEND_VERIFI_EMAIL, LBL_NOT_VERIFIED, LBL_ROLE, LBL_SEND_VERIFI_EMAIL, LBL_CONFIRM_DELETE_CONTACT, LBL_LAST_NAME, LBL_CONTACT_NUMBER, LBL_ADD_NEW, LBL_CLIENT_CONTACT, LBL_RESEND_EMAIL, LBL_CONFIRM_DELETE, LBL_PRIMARY } from '../../../configs/labelConfigs';
import { MSG_PUSH_CHANGES_UPDATED, MSG_EMAIL_CHANGES_UPDATED, MSG_CLIENT_CONTACT_INVALID_DETAILS, MSG_REQUIRED, MSG_FILE_SIZE_ERROR, MSG_FILE_FORMAT_ERROR, MSG_LOGO_FORMAT, MSG_NOT_FOUND, MSG_CLIENT_CNCT_DETAILS_ADD, MSG_CLIENT_CNCT_DETAILS_DELETE, MSG_CLIENT_CNCT_DETAILS_UPDATE, MSG_DUPLICATION, MSG_CLIENT_CNCT_SEND_MAIL, MSG_FILE_NAME_ERROR, MSG_FOLLOWING_CONTACT_NOT_IMPORTED, MSG_CLIENT_CONTACT_IMPORTED_SUCCESS, MSG_ALL_CONTACTS_ALREADY_IMPORT, MSG_DATA_SAVE_ERROR, MSG_FILE_NAME_STRAT_WITH } from '../../../configs/msgConfigs';
import { LOGIN_CLIENT_GROUP, IMPORT_CLIENT_CONTACT_CSV_FILE_NAME, PHONE_ISD_CODE, PHONE_ISD_NUM, } from '../../../configs/staticConfigs';
import ModalWindow from '../../commons/helpers/modalWindow';

import { clientContactListAction, clientContactImportAction, clientContactDeleteAction } from '../../../actions/clientActions';
import { assMuteEmailAction, assMutePushAction } from '../../../actions/assUserActions'; // assUserDeleteAction
import { clearAction, profileRoleGetAction } from '../../../actions/commonActions';

import { formValid, validateEmail, imageExtension, fileSize, csvFileCheck } from '../../../utils/validation';
import * as types from '../../../actions';
import PhoneInput from 'react-phone-input-2';
import Cropper from 'react-easy-crop'
import 'react-easy-crop/react-easy-crop.css'
import getCroppedImg from '../../commons/image-cropper/cropImage'
import ClientContactAdd from './clientContactAdd';
import Toast from '../../commons/helpers/toast';

class ContactDetails extends Component {

    constructor(props) {
        super()

        this.state = {
            activeRowId: 0,
            sortField: '-id',
            sortOrder: '',
            contactId: '',
            //roleId:'',
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            formErrors: {
                firstName: '',
                lastName: '',
                contactNumber: '',
                emailAddress: '',
                role: ''
            },
            contactData: {
                firstName: null,
                lastName: null,
                contactNumber: '',
                emailAddress: '',
                position: '',
                logo: '',
                sendEmail: false,
                emailVerify: false,
                role: '',
                primary_contact: false,
                muteMails: false,
                mutePushs: false
            },
            imgUrl: '',
            logoLabel: MSG_LOGO_FORMAT,
            isLogoValid: true,
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea: {},
            croppedAreaPixels: {},
            rotation: 0,
            imgObj: null,
            modifiedImg: null,
            saveFormDataClicked: 0,
            editContactClicked: 0,
            editContactId: 0,
            addContactClicked: 0,
            reloadContactList: 0,
        }
        this.openModal = this.openModal.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.callToaster = this.callToaster.bind(this);

        this.modal = React.createRef();
        this.modalCropper = React.createRef();
        this.modalDelete = React.createRef();
        this.contactModal = React.createRef();
        this.csvUploader = React.createRef();
    }


    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    refreshParent = (userData) => {
        this.contactModal.current.handleModelClose();
        this.setState({ editContactId: 0 });
        this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
    }

    onCropChange = crop => {
        this.setState({ crop })
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedArea, croppedAreaPixels: croppedAreaPixels })
    }

    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    openModal() {
        this.resetFormErrors();
        this.modal.current.handleOpenModal();
    }

    openContactModal = () => {
        let addContactClicked = this.state.addContactClicked + 1;
        this.setState({ addContactClicked: addContactClicked }, () => {
            this.contactModal.current.handleOpenModal();
        })
    }

    setCroppedImage() {
        this.modalCropper.current.handleModelClose();
    }

    cropImage(e) {
        let { imgObj, croppedAreaPixels, rotation, imgUrl } = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation
        )

    }

    onModalFormReset = () => {
        this.setState({
            contactId: '',
            editContactId: 0,
            contactData: {
                firstName: null,
                lastName: null,
                contactNumber: '',
                emailAddress: '',
                position: '',
                role: null,
                primary_contact: false,
                muteMails: false,
                mutePushs: false
            },
            imgUrl: '',
        });
    }

    resetFormErrors = () => {
        let formErrors = this.state.formErrors;
        formErrors.firstName = '';
        formErrors.lastName = '';
        formErrors.contactNumber = '';
        formErrors.emailAddress = '';
        this.setState({ formErrors });
    }

    onShowActionButtons = (event, rowId) => {

        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
        } else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        } else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
        }

    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    onHandleChange = (e) => {
        const { name } = e.target;
        let value = '';

        switch (e.target.type) {
            case 'file':
                value = e.target.files[0];
                break;
            case 'checkbox':
                value = e.target.checked;
                break;
            default:
                value = e.target.value;
                break;
        }

        let formErrors = this.state.formErrors;
        let logoValid = true;
        let logoError = MSG_LOGO_FORMAT;
        let trimmedValue = '';

        if (e.target.type === "text" || e.target.type === "tel" || e.target.type === "email") {
            trimmedValue = value.trim();
        }

        let contactData = this.state.contactData;

        switch (name) {
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if (!imageExtension(value.name)) {
                    logoError = MSG_FILE_FORMAT_ERROR;
                    logoValid = false;
                }
                break;
            case 'firstName': formErrors.firstName = trimmedValue.length <= 0 ? MSG_REQUIRED : ""
                formErrors.role = ""
                break;
            case 'lastName': formErrors.lastName = trimmedValue.length <= 0 ? MSG_REQUIRED : ""
                break;
            case 'contactNumber':
                formErrors.contactNumber = (contactData.primary_contact && trimmedValue.length <= 0) ? MSG_REQUIRED : ""
                break;
            case 'emailAddress':
                formErrors.emailAddress = (contactData.primary_contact && (trimmedValue.length <= 0 || validateEmail(value) === false)) ? MSG_REQUIRED : ""
                break;

            default:
                break;
        }


        contactData[name] = value;

        if (e.target.type === "file") {
            let imgUrl = '';
            let imgObj = null;
            if (imageExtension(e.target.files[0].name)) {
                imgObj = e.target.files[0]
                imgUrl = URL.createObjectURL(e.target.files[0]);
            }
            this.setState({ imgUrl: imgUrl, imgObj: imgObj });
            document.getElementById('uploadContactProfile').value = '';
            this.openCropModal()
        }

        this.setState({ formErrors, contactData, isLogoValid: logoValid, logoLabel: logoError });

    }

    onPhoneInputChange = (value, data, event, formattedValue) => {
        let contactData = this.state.contactData;
        let formErrors = this.state.formErrors;
        contactData['contactNumber'] = formattedValue.trim();
        if (contactData.primary_contact) {
            formErrors.contactNumber = value.trim() === data.dialCode ? MSG_REQUIRED : "";
            formErrors.contactNumber = formattedValue.trim().length < 5 ? MSG_REQUIRED : "";
            this.setState({ formErrors, contactData });
        }
        else {
            this.setState({ contactData });
        }
    }

    onHandleCsvImport = (e) => {
        e.preventDefault();
        this.csvUploader.current.click();
    }

    onHandleCSVChange = (e) => {

        const value =
            e.target.type === "file" ? e.target.files[0] : e.target.value;
        if (e.target.type === "file") {

            // if (!e.target.files[0].name.startsWith(IMPORT_CLIENT_CONTACT_CSV_FILE_NAME.split(".csv")[0])) {
            //     this.setToasterState(true, `${MSG_FILE_NAME_ERROR} ${MSG_FILE_NAME_STRAT_WITH} "${IMPORT_CLIENT_CONTACT_CSV_FILE_NAME.split(".csv")[0]}"`, false);
            // } else
             if (csvFileCheck(e.target.files[0].name)) {
                const data = new FormData();
                data.append('file', value);
                data.append('client_profile_id', this.props.clientId);
                this.props.clientContactImportAction(data);
            } else {
                this.callToaster(true, MSG_FILE_FORMAT_ERROR, false);
            }

        }
    }

    validateForm = () => {
        let contactData = this.state.contactData;
        let formErrors = this.state.formErrors;
        let foundIssues = 0;
        if (!contactData.firstName || contactData.firstName.trim().length === 0) {
            foundIssues = 1;
            formErrors.firstName = MSG_REQUIRED;
        }
        if (!contactData.lastName || contactData.lastName.trim().length === 0) {
            foundIssues = 1;
            formErrors.lastName = MSG_REQUIRED;
        }
        if (contactData.primary_contact && (!contactData.contactNumber || contactData.contactNumber.trim().length === 0)) {
            foundIssues = 1;
            formErrors.contactNumber = MSG_REQUIRED;
        }
        if (contactData.primary_contact && (!contactData.emailAddress || contactData.emailAddress.trim().length === 0 || validateEmail(contactData.emailAddress) === false)) {
            foundIssues = 1;
            formErrors.emailAddress = MSG_REQUIRED;
        }
        if (foundIssues) {
            this.setState({ formErrors });
            return false;
        }
        else {
            return true;
        }
    }

    onSaveFormData = (e) => {
        let saveFormDataClicked = this.state.saveFormDataClicked + 1;

        this.setState({ saveFormDataClicked });

        // let contactData   = this.state.contactData;  
        // if(this.validateForm()) { // if(formValid(this.state))
        //     const data   = new FormData();
        //     let role = document.getElementsByName('role')[0].value; 
        //     data.append('client_profile', this.props.clientId);   
        //     data.append('first_name', contactData.firstName);            
        //     data.append('last_name', contactData.lastName);
        //     data.append('mobile', contactData.contactNumber);
        //     data.append('email', contactData.emailAddress);
        //     data.append('position', contactData.position);
        //     data.append('role', role); 
        //     data.append('send_mail', contactData.sendEmail?1:0);

        //     data.append('profile_picture', contactData.logo);                 
        //     if(this.state.contactId){
        //         data.append('assUserId', this.state.contactId);
        //         data.append('status', 1);
        //         this.props.assUserUpdateAction(data);
        //     }else{
        //         this.props.clientContactAddAction(data);
        //     }

        // }



        /*
        else{
            let formErrors    = this.state.formErrors; 
            if(contactData.firstName===null){
                formErrors.firstName = MSG_REQUIRED;
            }
            if(contactData.lastName===null){
                formErrors.lastName = MSG_REQUIRED;
            }  
            if(contactData.contactNumber===null){
                formErrors.contactNumber = MSG_REQUIRED;
            } 
            if(contactData.emailAddress===null){
                formErrors.emailAddress = MSG_REQUIRED;
            }               
            this.setState({formErrors});
        }
        */
    }

    editBtnClick = (userId) => {
        // this.resetFormErrors();
        // this.props.assUserEditAction(userId);
        let editContactClicked = this.state.editContactClicked + 1;
        this.setState({ editContactClicked: editContactClicked, editContactId: userId }, () => {
            this.contactModal.current.handleOpenModal();
        });

    }

    openCropModal = () => {
        this.modalCropper.current.handleOpenModal();
    }

    deleteBtnClick = (rowId) => {
        this.setState({
            contactId: rowId
        });
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        let contactId = this.state.contactId;
        this.props.clientContactDeleteAction(contactId);
        this.modalDelete.current.handleModelClose();
    }

    onSort = (event, sortKey) => {
        let sOrder = '';
        if (this.state.sortField === sortKey) {
            sOrder = (this.state.sortOrder === '-') ? '' : '-';
            this.props.clientContactListAction({ clientId: this.props.clientId, column: sOrder + this.state.sortField });
            this.setState({ sortOrder: sOrder });
        } else {
            this.setState({ sortField: sortKey });
            this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + sortKey });
        }
    }

    setStateUpdate(subactivity, status, contactUser, roles, errorData, sendMailStatus, contactImportData, alreadyImported) {
        let formErrors = this.state.formErrors;
        /* 
        if(subactivity===types.CLIENT_CONTACT_ADD_SUCCESS){  
            this.modal.current.handleModelClose();
            this.callToaster(true,MSG_CLIENT_CNCT_DETAILS_ADD,true);
            this.props.clientContactListAction({clientId:this.props.clientId,column:this.state.sortOrder+this.state.sortField});
        }else if(subactivity===types.CLIENT_CONTACT_ADD_ERROR){  
            if(status===400){
                formErrors.emailAddress = MSG_DUPLICATION;
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.callToaster(true,errorData.message,false);
                }else{
                    this.callToaster(true,JSON.stringify(errorData),false);
                }
            }
        }else if(subactivity===types.ASS_USER_EDIT_SUCCESS){
            this.setState({
                contactData:{
                    firstName:contactUser.firstName,
                    lastName:contactUser.lastName,
                    contactNumber:contactUser.contactNumber,
                    emailAddress:contactUser.emailAddress,
                    position:contactUser.position,
                    logo:'',
                    emailVerify:contactUser.emailVerify,
                    role:contactUser.role,
                    primary_contact:contactUser.primary_contact?contactUser.primary_contact:false 
                },
                contactId:contactUser.userId,
                imgUrl:contactUser.logo,
            });
        }else if(subactivity===types.ASS_USER_UPDATE_SUCCESS){
            this.modal.current.handleModelClose();
            if(sendMailStatus==='1'){
                this.callToaster(true,MSG_CLIENT_CNCT_SEND_MAIL,true,false);
            }else{
                this.callToaster(true,MSG_CLIENT_CNCT_DETAILS_UPDATE,true);
            }
            this.props.clientContactListAction({clientId:this.props.clientId,column:this.state.sortOrder+this.state.sortField});
        }else if(subactivity===types.ASS_USER_UPDATE_ERROR){
            if(status===400){
                formErrors.emailAddress = MSG_DUPLICATION;
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.callToaster(true,errorData.message,false);
                }else{
                    this.callToaster(true,JSON.stringify(errorData),false);
                }
            }
        }else 
        */
        if (subactivity === types.PROFILE_ROLE_SUCCESS) {
            // let userRole = roles.filter((role) => role.name === 'admin');
            // if(roles.length>0){
            //     this.setState({roleId:userRole[0].id});
            // }
        }
    }

    componentDidUpdate(prevProps) {
        const { assoActivity, assoStatus, importSubactivity, status, subactivity, contactUser, roles, errorData, sendMailStatus, contactImportData, alreadyImported, reloadContactList } = this.props;
        if (subactivity !== prevProps.subactivity || importSubactivity !== prevProps.importSubactivity) {
            this.setStateUpdate(importSubactivity, subactivity, status, contactUser, roles, errorData, sendMailStatus, contactImportData, alreadyImported);
            this.props.clearAction();
        }
        if (importSubactivity !== prevProps.importSubactivity) {
            let arrTemp = importSubactivity.split('~~');
            let actString = arrTemp[0];
            let message = "";
            if (actString === types.CLIENT_CONTACT_IMPORT_SUCCESS) {
                this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
                if (alreadyImported) {
                    this.callToaster(true, MSG_ALL_CONTACTS_ALREADY_IMPORT, true);
                } else {
                    if (contactImportData.existing_emails && contactImportData.existing_emails.length > 0) {
                        message += MSG_FOLLOWING_CONTACT_NOT_IMPORTED;
                        message += contactImportData.existing_emails.join(',\n\t');
                    } if (contactImportData.invalid_contact_details && contactImportData.invalid_contact_details.length > 0) {
                        if (message.length > 0) {
                            message += "<p>   </p>"
                        }
                        message += MSG_CLIENT_CONTACT_INVALID_DETAILS;
                        message += contactImportData.invalid_contact_details.join(',\n\t');
                    } if (message.length > 0) {
                        this.callToaster(true, message, false, false, 8000);

                    } else {
                        this.callToaster(true, MSG_CLIENT_CONTACT_IMPORTED_SUCCESS, true);
                    }
                }
                document.getElementsByName("csvFile-contact")[0].value = "";

            } else if (actString === types.CLIENT_CONTACT_IMPORT_ERROR) {
                //let message = "";
                if ("message" in errorData) {
                    this.callToaster(true, errorData.message, false, false);
                } else {
                    this.callToaster(true, JSON.stringify(errorData), false, false);
                }
                document.getElementsByName("csvFile-contact")[0].value = "";

            } else if (actString === types.CLIENT_CONTACT_DELETE_SUCCESS) {
                this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
                this.callToaster(true, MSG_CLIENT_CNCT_DETAILS_DELETE, true);
            } else if (actString === types.CLIENT_CONTACT_DELETE_ERROR) {
                this.callToaster(true, MSG_DATA_SAVE_ERROR, true);
                console.log(JSON.stringify(errorData));
            }
        }



        if (assoActivity !== prevProps.assoActivity) {
            let arrTemp = assoActivity.split('~~');
            let actString = arrTemp[0];
            if (actString === types.UPDATE_ASSO_MUTE_EMAIL_SUCCESS) {
                this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
                this.callToaster(true, MSG_EMAIL_CHANGES_UPDATED, true)
            } else if (actString === types.UPDATE_ASSO_MUTE_PUSH_SUCCESS) {
                this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
                this.callToaster(true, MSG_PUSH_CHANGES_UPDATED, true)
            }
        }


        if (reloadContactList && Number(reloadContactList) > Number(this.state.reloadContactList)) {
            this.setState({ reloadContactList: reloadContactList }, () => {
                this.reloadContactDetails();
            })
        }
    }

    reloadContactDetails = () => {
        if (this.props.clientId) {
            this.props.clientContactListAction({ clientId: this.props.clientId, column: this.state.sortOrder + this.state.sortField });
            this.props.profileRoleGetAction({ profileId: this.props.clientId, userType: LOGIN_CLIENT_GROUP });
        }
    }

    componentDidMount() {
        this.reloadContactDetails();
    }

    callToaster(isEnabled, message, isSucces, isAutoHide = true, delay = 5000) {
        this.props.setToasterState(isEnabled, message, isSucces, isAutoHide, delay);
    }

    onHandleChangeMail = (e, assoId) => {
        let value = e.target.checked;
        this.props.assMuteEmailAction({ id: assoId, data: { value: value } });
    }
    onHandleChangePush = (e, assoId) => {
        let value = e.target.checked;
        this.props.assMutePushAction({ id: assoId, data: { value: value } });
    }

    render() {

        const { formErrors, contactData, imgUrl, logoLabel, isLogoValid, contactId } = this.state;
        const { contactList, count, roles, isSuperAdmin, } = this.props;

        let companyName = '';
        if (this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;

        let logoUrl = require('../../../' + URL_IMG + 'profile-image.png');
        if (imgUrl) {
            logoUrl = imgUrl;
        }

        return (
            <div className="form-group col-md-12">
                <div className="box margin-top-12">
                    <Toast toastDescription={this.state.toastMessagePop} toastFlag={this.state.toastFlagPop} toastSuccess={this.state.toastSuccessPop} closeToast={this.onCloseToastPop} />
                    {!isSuperAdmin && <>
                        <div className="tab-head">
                            {/* <h6>{LBL_CONTACT_DETAILS} {(companyName) && <span>{' - '+companyName}</span>} </h6> */}
                            <h6>&nbsp;</h6>

                            <div className="to-right">
                                <button className="btn btn-primary launch-modal" onClick={this.openContactModal}>{LBL_ADD_NEW}</button>
                            </div>
                            <div className="to-right filter-btn-wrapper">
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip id="download-tooltip" style={{ opacity: 0.4, }}>{LBL_CSV_IMPORT}</Tooltip>}
                                >
                                    <Link to="#" onClick={(e) => this.onHandleCsvImport(e)} className="btn btn-outline-primary filter-btn"><i className="las la-file-import i-margin-top"></i> </Link>
                                </OverlayTrigger>
                                <input name="csvFile-contact" type="file" accept=".csv" id="file" ref={this.csvUploader} onChange={this.onHandleCSVChange} style={{ display: "none" }} />
                            </div>
                        </div>
                    </>}
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th onClick={(e) => this.onSort(e, 'user__first_name')} className="client-name sorting_asc">{LBL_NAME}</th>
                                        <th onClick={(e) => this.onSort(e, 'position')} className="position sorting_asc">{LBL_POSITION}</th>
                                        <th onClick={(e) => this.onSort(e, 'user__email')} className="sorting_asc">{LBL_EMAIL}</th>
                                        <th onClick={(e) => this.onSort(e, 'phone_number')} className="phone sorting_asc">{LBL_PHONE}</th>
                                        {!isSuperAdmin && <>
                                            <th className="text-center">{LBL_MUTE_EMAILS}</th>
                                            <th className="text-center">{LBL_MUTE_NOTICATIONS}</th>
                                            <th className="action">&nbsp;</th>
                                        </>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {(count === 0) &&
                                        <tr>
                                            <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    }
                                    {Array.isArray(contactList) && contactList.map((item, index) => {

                                        return (
                                            <tr key={item.user.id}>
                                                <td>{index + 1}</td>
                                                <td><Link to="#" onClick={(e) => this.editBtnClick(item.user.id)} >{item.user.first_name + ' ' + item.user.last_name}</Link> {item.primary_contact && <sup>{' '+LBL_PRIMARY}</sup>}</td>
                                                <td>{item.position}</td>
                                                <td>
                                                    <div>{item.user.email}</div>
                                                    <div className="divFloatLeft"><small className="block text-red">{item.email_verified ? '' : 'Not Verified'}</small></div>
                                                    {item.user.id > 0 && item.user.email.length > 0 && !item.email_verified && <Link className={'resend-btn float-right'} to="#" onClick={e => this.props.resendEmail(item.user.id)}><small className="block">{LBL_RESEND_EMAIL}</small></Link>}
                                                </td>
                                                <td>{item.phone_number}</td>
                                                {!isSuperAdmin && <>
                                                    <td className="text-center">
                                                        <div className="form-group">
                                                            <div className="custom-checkbox padding-right-0"><input type="checkbox" id={"chkInductionCrew_email_" + index} name={"chkInductionCrew_email_" + index} onChange={(e) => this.onHandleChangeMail(e, item.id)} checked={item.mute_mails} />
                                                                <label className="checkbox" htmlFor={"chkInductionCrew_email_" + index}></label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="form-group">
                                                            <div className="custom-checkbox padding-right-0"><input type="checkbox" id={"chkInductionCrew_push_" + index} name={"chkInductionCrew_push_" + index} onChange={(e) => this.onHandleChangePush(e, item.id)} checked={item.mute_pushs} />
                                                                <label className="checkbox" htmlFor={"chkInductionCrew_push_" + index}></label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="dropdown" id={'dropdown-' + item.user.id}>
                                                            <button className="dropdown-toggle" type="button"
                                                                id={'dropdownMenuButton-' + item.user.id} data-toggle="dropdown"
                                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.user.id)}
                                                                onBlur={(e) => this.onHideActionButtons(e, item.user.id)}
                                                            >
                                                                <img id="test" src={require('../../../' + URL_IMG + 'action.png')} alt="Action" />
                                                            </button>
                                                            <div className="dropdown-menu" id={'dropdown-menu-' + item.user.id}
                                                                aria-labelledby={'dropdownMenuButton-' + item.user.id}>
                                                                <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.user.id)}>{LBL_EDIT}</Link>
                                                                {item.primary_contact === false && (
                                                                    <Link className="dropdown-item delete"
                                                                        to="#" onMouseDown={(e) => this.deleteBtnClick(item.user.id)}>{LBL_DELETE}</Link>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </>
                                                }
                                            </tr>
                                        )
                                    })

                                    }

                                </tbody>
                            </table>
                            <div className="clear-b-scroll-settings">&nbsp;</div>
                            <div className="padding-top-50">&nbsp;</div>
                            <div className="padding-top-50">&nbsp;</div>
                        </div>
                    </div>

                    <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>{LBL_CONFIRM_DELETE_CONTACT}</ModalWindow>

                    <ModalWindow ref={this.modalCropper} type="imageCropper" saveFormData={(e) => this.cropImage(e)}>
                        <Cropper
                            image={logoUrl}
                            crop={this.state.crop}
                            zoom={this.state.zoom}
                            aspect={this.state.aspect}
                            onCropChange={this.onCropChange}
                            onCropComplete={this.onCropComplete}
                            onZoomChange={this.onZoomChange}
                        />
                    </ModalWindow>

                    <ModalWindow ref={this.contactModal} header={LBL_CLIENT_CONTACT} saveFormData={(e) => this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="save" >
                        <ClientContactAdd saveFormDataClicked={this.state.saveFormDataClicked} refreshParent={this.refreshParent} clientId={this.props.clientId} editContactClicked={this.state.editContactClicked} editContactId={this.state.editContactId} setToasterStatePop={this.setToasterStatePop} addContactClicked={this.state.addContactClicked} ></ClientContactAdd>
                    </ModalWindow>


                    {/* <ModalWindow ref={this.modal} header={LBL_CLIENT_CONTACT} saveFormData={ (e)=>this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="save" >
                    <Form>
                        <Form.Group>
                            <Row>
                                <div className="col-md-12 text-center">
                                    <div className="company-logo">
                                    <img src={logoUrl} alt={LBL_PROFILE_NAME} />  
                                    <p className={isLogoValid?'logo-txt':'text-red logo-txt'}><small>{logoLabel}</small></p>                                          
                                    <label htmlFor="uploadContactProfile"><i className="las la-pen"></i></label> 
                                    <input type="file" id="uploadContactProfile" name="logo" onChange={this.onHandleChange} accept=".png, .jpg"/>                                          
                                </div>
                                </div>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_FIRST_NAME}</label>
                                        <div className="text-input"><input type="text" name="firstName" onChange={this.onHandleChange} className={formErrors.firstName.length >0 ? "input-error" : ''} value={contactData.firstName || ''} tabIndex="1" /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_LAST_NAME}</label>
                                        <div className="text-input"><input type="text" className={formErrors.lastName.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="lastName" value={contactData.lastName || ''}  tabIndex="2" /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_CONTACT_NUMBER}</label>
                                        <div className={formErrors.contactNumber.length>0?'input-error':''}>
                                            <PhoneInput 
                                              country={PHONE_ISD_CODE}
                                              inputProps={{
                                                name: 'contactNumber',
                                                tabIndex: "3"
                                              }}
                                              value={contactData.contactNumber || PHONE_ISD_NUM}
                                              onChange={this.onPhoneInputChange} 
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_EMAIL_ADDRESS}</label>
                                        <div className="input email-input"><input type="email" className={formErrors.emailAddress.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="emailAddress" value={contactData.emailAddress || ''}  tabIndex="4" />
                                        {formErrors.emailAddress.length >0 && formErrors.emailAddress!==MSG_REQUIRED && (
                                            <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                                        )} 
                                        <small className="text-red">{contactData.emailVerify===false&&contactData.emailAddress?LBL_NOT_VERIFIED:''}</small>
                                        <Link className={contactData.emailVerify===false&&contactData.emailAddress?'resend-btn float-right':'hide'} to="#" onClick={e => this.props.resendEmail(contactId)}  >{LBL_RESEND_VERIFI_EMAIL}</Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_ROLE}</label>
                                        <div className="select-input disabledElement">
                                        <select name="role" onChange={this.onHandleChange} name="role" value={contactData.role || 0} className={''} disabled  tabIndex="6">
                                            
                                            {roles.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}  
                                        </select>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_POSITION}</label>
                                        <div className="input-input"><input  type="text" onChange={this.onHandleChange} name="position" value={contactData.position || ''}  tabIndex="7" /></div>
                                    </div>
                                </Col>                        
                            </Row>
                            <Row>
                                <Col md={6} >
                                    <div className="checkbox-wrapper conct-detailss form-group">
                                        <label></label>
                                        <div className="custom-checkbox">
                                            <input onChange={this.onHandleChange} name="sendEmail" 
                                            checked={contactData.sendEmail||false} type="checkbox" id="sendEmail" disabled={contactData.emailVerify}  tabIndex="8" /><label className="checkbox" htmlFor="sendEmail"  tabIndex="8"  ></label><label className="labeltext" htmlFor="sendEmail">{LBL_SEND_VERIFI_EMAIL}</label>
                                        </div>
                                    </div> 
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </ModalWindow>  */}
                    {/*roles && roles.length > 1 &&  <option value="0">Select Role</option> */}
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        contactList: state.clients.contactList,
        count: state.clients.count,
        contactUser: state.clients.contactUser,
        status: state.clients.status,
        subactivity: state.clients.subactivity,
        importSubactivity: state.clients.importSubactivity,
        roles: state.clients.roles,
        errorData: state.clients.errorData,
        sendMailStatus: state.clients.sendMailStatus,
        contactImportData: state.clients.contactImportData,
        alreadyImported: state.clients.alreadyImported,
        assoActivity: state.assocUsers.activity,
        assoStatus: state.assocUsers.status,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clientContactListAction: clientContactListAction,
        clientContactImportAction: data => clientContactImportAction(data),
        clientContactDeleteAction: id => clientContactDeleteAction(id),
        profileRoleGetAction: profileRoleGetAction,
        clearAction: clearAction,
        assMuteEmailAction: assMuteEmailAction,
        assMutePushAction: assMutePushAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);